// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#blur-background {
  display: none;
}

#blur-background.active {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

/* #checkin-confirm{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  z-index: 5000;
  display: none;
}


.login-button{
  position: absolute;
  top: 20px;
  right: 120px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 1000;
}

.signup-button {
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 1000;
}

.findme-button, .return-centre-button {
  position: absolute;
  top: 20px;
  left: 40px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 1000;
}

.return-centre-button{
  left: 160px;
}

.button:hover {
  background-color: #0056b3;
}


.pop-up-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px;
  margin: 5px;
  cursor: pointer;
  border-radius: 5px;
}

.pop-up-button:hover {
  background-color: #0056b3;
} */


.signup-form-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  z-index: 5000;
  overflow-y: auto;
  height: 80vh;
  width: 50vw;
  border-radius:10px;
}


/* #username-input, #password, #email, input[type=text]{
  margin-top:10px;
  width:95%;
}


.info-button{
  width:20px;
  padding: 5px;
  background-color: #007bff;
  border: none;
  border-radius: 50px;
  color: white;
  margin: 0.25em;
  margin-left:5px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease, colour 0.3s ease;
} */


@media (max-width: 1042px) {
  .signup-form-container{
    height: 40vh;
    width: 70vw;
  }

  .continue-button{
    margin-top:50px;
  }
}

@media (max-width: 769px) {
  .signup-form-container{
      height: 50vh;
      width: 70vw;
  }

  .continue-button{
    margin-top:40px;
  }
}

@media (max-width: 500px) {
  .info-button{
      width:5%;
  }
  /* #username-input, #password, #email, input[type=text] {
    width:79%;
  } */
  .signup-form-container{
    height: 70vh;
    width: 80vw;
  }
}

.sign-up-popup{
  z-index:100000;
}

/* @media (max-width: 375px) {
  .info-button{
      width:10%;
  }
  #username-input, #password, #email, input[type=text], input-box-short{
    width:75%;
  }

  .continue-button{
    margin-top:0px;
  }
}

.input-box-short{
  margin-top:5px;
}

/* input{
  width: 94%;
  padding:20px;
  margin-bottom:10px;
  text-align: center;
  border-radius: 10px;
  border-color:  #007bff;
} */

/* .sign-up-input{
  width: 94%;
  padding:20px;
  margin-bottom:10px;
  text-align: center;
  border-radius: 10px;
  border-color:  #007bff;
} */

/* textarea {
  width:90%;
  border-radius: 10px;
  border-color:  #007bff;
}

select{
  width: 85%;
  padding:10px;
  margin-bottom:10px;
  text-align: center;
  border-radius: 10px;
  border-color:  #007bff;
}

#label-input{
  width:75%;
  margin-right:1%
}

.checkbox-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.continue-button{
  text-align:center;
}

.toggle-page-view{
  margin-top:40px;
  width:100%;
}

.toggle-page-view:hover {
  background-color: #004c9e;
}

.info-button:hover{
  background-color:#004c9e;
}

.signup-form fieldset {
  border: 1px solid #ddd;
  padding: 20px;
  margin-bottom: 10px;
}

.checkbox-option {
  margin-top:10px;
  display: flex;
  justify-content:left;
}


#visiting-span, #consent-span, .checkbox-label{
  width:100%;
}

#visiting-checkbox, #consent, .label-checkbox{
  width:20%;
}

#visiting-checkbox{
  margin-right:50%;
}

@media(max-width:500px){
    #visiting-checkbox{
        margin-right:10%;
    }
}

input[type="checkbox"] {
  margin-left: 10px;
  vertical-align: middle;
}

.checkbox-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.checkbox-label {
  margin-right: 10px;
} 

.label-heading {
  width:70%;
}

.label-header{
  display: flex;
  justify-content: space-between;
}

.label-header button{
  width:11%;
  height:10%;
  padding-top:5px;
  padding-bottom:5px;
  background-color: #007bff;
  border: none;
  border-radius: 50px;
  color: white;
  margin-right:3%;
  margin-top:7%;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease, colour 0.3s ease;
}


.page-title {
  font-weight: bold;
  font-size: 22px;
  text-align: center;
  margin-bottom: 10px;
  margin-top:0px;
}

.button-container{
  text-align: center;
}

.button-container button{
  width:48%;
} */


.event-form-container {
  position: fixed;
  height:90%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  z-index: 5000;
  display: none;
  overflow:auto;
  border-radius:15px;
} 

.event-form-container.active {
  display: block;
} 

.gender-label{
  padding-right:10px;
} 

.form-input {
  /* padding:8px;
  margin-bottom:5px; */
  border-radius: 10px !important;
  border-color:  #007bff !important;
}

.gaelic-ability-container{
  display: flex;
  justify-content: space-around;
}

#Gaelic_ability{
  width:90%;
}


.info-button{
  border-radius: 50px !important;
} 

.label-button{
  border-radius: 50px !important;
  font-size:12px !important;
} 

select{
  appearance: menulist !important;
}


.sign-up-form-header {
  display: flex;
  justify-content: space-between;
  vertical-align: middle;
}

.form-action-button{
  width:48%;
  border-radius: 50px !important
}


`, "",{"version":3,"sources":["webpack://./src/css/signup.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAyEG;;;AAGH;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;;AAGA;;;;;;;;;;;;;;;;;;GAkBG;;;AAGH;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;MACI,YAAY;MACZ,WAAW;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;MACI,QAAQ;EACZ;EACA;;KAEG;EACH;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;GAwBG;;AAEH;;;;;;;GAOG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiIG;;;AAGH;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;sBACoB;EACpB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;;AAGA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT;AACF","sourcesContent":["#blur-background {\n  display: none;\n}\n\n#blur-background.active {\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n}\n\n/* #checkin-confirm{\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  padding: 20px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n  z-index: 5000;\n  display: none;\n}\n\n\n.login-button{\n  position: absolute;\n  top: 20px;\n  right: 120px;\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  z-index: 1000;\n}\n\n.signup-button {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  z-index: 1000;\n}\n\n.findme-button, .return-centre-button {\n  position: absolute;\n  top: 20px;\n  left: 40px;\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  z-index: 1000;\n}\n\n.return-centre-button{\n  left: 160px;\n}\n\n.button:hover {\n  background-color: #0056b3;\n}\n\n\n.pop-up-button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 10px;\n  margin: 5px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.pop-up-button:hover {\n  background-color: #0056b3;\n} */\n\n\n.signup-form-container {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  padding: 20px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n  z-index: 5000;\n  overflow-y: auto;\n  height: 80vh;\n  width: 50vw;\n  border-radius:10px;\n}\n\n\n/* #username-input, #password, #email, input[type=text]{\n  margin-top:10px;\n  width:95%;\n}\n\n\n.info-button{\n  width:20px;\n  padding: 5px;\n  background-color: #007bff;\n  border: none;\n  border-radius: 50px;\n  color: white;\n  margin: 0.25em;\n  margin-left:5px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, colour 0.3s ease;\n} */\n\n\n@media (max-width: 1042px) {\n  .signup-form-container{\n    height: 40vh;\n    width: 70vw;\n  }\n\n  .continue-button{\n    margin-top:50px;\n  }\n}\n\n@media (max-width: 769px) {\n  .signup-form-container{\n      height: 50vh;\n      width: 70vw;\n  }\n\n  .continue-button{\n    margin-top:40px;\n  }\n}\n\n@media (max-width: 500px) {\n  .info-button{\n      width:5%;\n  }\n  /* #username-input, #password, #email, input[type=text] {\n    width:79%;\n  } */\n  .signup-form-container{\n    height: 70vh;\n    width: 80vw;\n  }\n}\n\n.sign-up-popup{\n  z-index:100000;\n}\n\n/* @media (max-width: 375px) {\n  .info-button{\n      width:10%;\n  }\n  #username-input, #password, #email, input[type=text], input-box-short{\n    width:75%;\n  }\n\n  .continue-button{\n    margin-top:0px;\n  }\n}\n\n.input-box-short{\n  margin-top:5px;\n}\n\n/* input{\n  width: 94%;\n  padding:20px;\n  margin-bottom:10px;\n  text-align: center;\n  border-radius: 10px;\n  border-color:  #007bff;\n} */\n\n/* .sign-up-input{\n  width: 94%;\n  padding:20px;\n  margin-bottom:10px;\n  text-align: center;\n  border-radius: 10px;\n  border-color:  #007bff;\n} */\n\n/* textarea {\n  width:90%;\n  border-radius: 10px;\n  border-color:  #007bff;\n}\n\nselect{\n  width: 85%;\n  padding:10px;\n  margin-bottom:10px;\n  text-align: center;\n  border-radius: 10px;\n  border-color:  #007bff;\n}\n\n#label-input{\n  width:75%;\n  margin-right:1%\n}\n\n.checkbox-container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.continue-button{\n  text-align:center;\n}\n\n.toggle-page-view{\n  margin-top:40px;\n  width:100%;\n}\n\n.toggle-page-view:hover {\n  background-color: #004c9e;\n}\n\n.info-button:hover{\n  background-color:#004c9e;\n}\n\n.signup-form fieldset {\n  border: 1px solid #ddd;\n  padding: 20px;\n  margin-bottom: 10px;\n}\n\n.checkbox-option {\n  margin-top:10px;\n  display: flex;\n  justify-content:left;\n}\n\n\n#visiting-span, #consent-span, .checkbox-label{\n  width:100%;\n}\n\n#visiting-checkbox, #consent, .label-checkbox{\n  width:20%;\n}\n\n#visiting-checkbox{\n  margin-right:50%;\n}\n\n@media(max-width:500px){\n    #visiting-checkbox{\n        margin-right:10%;\n    }\n}\n\ninput[type=\"checkbox\"] {\n  margin-left: 10px;\n  vertical-align: middle;\n}\n\n.checkbox-container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.checkbox-label {\n  margin-right: 10px;\n} \n\n.label-heading {\n  width:70%;\n}\n\n.label-header{\n  display: flex;\n  justify-content: space-between;\n}\n\n.label-header button{\n  width:11%;\n  height:10%;\n  padding-top:5px;\n  padding-bottom:5px;\n  background-color: #007bff;\n  border: none;\n  border-radius: 50px;\n  color: white;\n  margin-right:3%;\n  margin-top:7%;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, colour 0.3s ease;\n}\n\n\n.page-title {\n  font-weight: bold;\n  font-size: 22px;\n  text-align: center;\n  margin-bottom: 10px;\n  margin-top:0px;\n}\n\n.button-container{\n  text-align: center;\n}\n\n.button-container button{\n  width:48%;\n} */\n\n\n.event-form-container {\n  position: fixed;\n  height:90%;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  padding: 20px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n  z-index: 5000;\n  display: none;\n  overflow:auto;\n  border-radius:15px;\n} \n\n.event-form-container.active {\n  display: block;\n} \n\n.gender-label{\n  padding-right:10px;\n} \n\n.form-input {\n  /* padding:8px;\n  margin-bottom:5px; */\n  border-radius: 10px !important;\n  border-color:  #007bff !important;\n}\n\n.gaelic-ability-container{\n  display: flex;\n  justify-content: space-around;\n}\n\n#Gaelic_ability{\n  width:90%;\n}\n\n\n.info-button{\n  border-radius: 50px !important;\n} \n\n.label-button{\n  border-radius: 50px !important;\n  font-size:12px !important;\n} \n\nselect{\n  appearance: menulist !important;\n}\n\n\n.sign-up-form-header {\n  display: flex;\n  justify-content: space-between;\n  vertical-align: middle;\n}\n\n.form-action-button{\n  width:48%;\n  border-radius: 50px !important\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
